import { render, staticRenderFns } from "./statside.vue?vue&type=template&id=57dd5c53&scoped=true&"
import script from "./statside.vue?vue&type=script&lang=js&"
export * from "./statside.vue?vue&type=script&lang=js&"
import style0 from "./statside.vue?vue&type=style&index=0&id=57dd5c53&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57dd5c53",
  null
  
)

export default component.exports